import Chart from 'chart.js';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Inject } from 'vue-di-container';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Toaster } from '../../Services/toast';
import UserRoleService from '../../shared/userService/UserRoleService';
import UserService from '../../shared/userService/UserService';
import { EmployeeDropdownModel } from './EmployeeDropdownModel';
import WithRender from './EmployeeStatistics.html';
import { EmployeeStatisticsBarChartModel } from './EmployeeStatisticsBarChartModel';
import { EmployeeStatisticsBoxModel } from './EmployeeStatisticsBoxModel';
import { EmployeeStatisticsChartModel } from './EmployeeStatisticsChartModel';
import EmployeeStatisticsService from './EmployeeStatisticsService';
import { FilterModel } from './FilterModel';
import { SenderRequestHistoryModel } from './SenderRequestHistoryModel ';


@WithRender
@Component({
    diProvide: [
        UserService,
        UserRoleService,
        EmployeeStatisticsService,
    ],
})
export default class EmployeeStatistics extends Vue {
    @Inject(EmployeeStatisticsService) public employeeStatisticsService!: EmployeeStatisticsService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public pieChartData: any = '';
    public barChartData: any = '';
    public viewBy: number = 1;
    public senderRequestHistoryModel: SenderRequestHistoryModel[] = [];
    public pieChartColors: string[] = [];
    public pieChartColorsList: string[] = [];
    public themeCompany: any = 'Default';
    public requestType: number = 0;
    public requestStatus: number = 0;
    public myPieChart: any;
    public myBarChart: any;
    public ctx: any;
    public processingBy: EmployeeDropdownModel[] = [];
    public filterModel: FilterModel = {
        senderName: '',
        requestId: '',
        processingById: '',
        requestStatus: 0,
        requestType: null,
        dateFrom: '',
        dateTo: ''
    };
    public processingDateFromMenu: boolean = false;
    public processingDateToMenu: boolean = false;
    public senderName: string = '';
    public autoInterval: any;
    public scrollDiv: any;
    public isEmptyPieChart: boolean = false;
    public nextPage: string = '';
    public scrollTop: number = 0;
    public sendersCount: number = 0;
    public pagination: any = {};
    public headers: any = [
        { text: this.$t('dashboardPage.requestId'), sortable: false, value: 'requestId', align: 'center' },
        { text: this.$t('dashboardPage.senderName'), sortable: false, value: 'senderName', align: 'center' },
        { text: this.$t('dashboardPage.clientName'), sortable: false, value: 'clientName', align: 'center' },
        { text: this.$t('dashboardPage.providerName'), sortable: false, value: 'providerName', align: 'center' },
        {
            text: this.$t('employeeStatistics.processingDate'), sortable: false,
            value: 'processingDate', align: 'center',
        },
        {
            text: this.$t('employeeStatistics.processingResult'), sortable: false,
            value: 'processingResult', align: 'center',
        },
        {
            text: this.$t('employeeStatistics.requestType'), sortable: false,
            value: 'requestType', align: 'center',
        },
        {
            text: this.$t('employeeStatistics.processingBy'), sortable: false,
            value: 'processingBy', align: 'center',
        },
    ];
    public viewByOption: any =
        [
            { "id": 1, "name": "View by week" },
            { "id": 2, "name": "View by month" },
            { "id": 3, "name": "View by 3 months" },
        ];
    public requestOption: any =
        [
            { "id": 0, "name": "All request types" },
            { "id": 1, "name": "Sender registration requests" },
            { "id": 2, "name": "New contract requests" },
            { "id": 3, "name": "Contracts renewal requests" },
        ];
    public employeeStatisticsBarChartModel: EmployeeStatisticsBarChartModel = {} as EmployeeStatisticsBarChartModel;
    public employeeStatisticsChartModelList: EmployeeStatisticsChartModel = {} as EmployeeStatisticsChartModel;
    public employeeNameList: string[] = [];
    public rejectedColor: string = '';
    public approvedColor: string = '';
    public finalApprovedColor: string = '';
    public requestCountList: number[] = [];
    public employeeNameBarList: string[] = [];
    public rejectedRequestCountBarList: number[] = [];
    public approvedRequestCountBarList: number[] = [];
    public finalApprovesRequestCountBarList: number[] = [];
    public employeeStatisticsBoxModel: EmployeeStatisticsBoxModel = {} as EmployeeStatisticsBoxModel;
    public async mounted() {
        await this.getColors();
        this.initializeBarChartHeight();
        await this.GetBoxes();
        await this.GetPieChart();
        await this.GetBarChart();
        this.createPiechart();
        this.createBarChart();
        await this.GetAllEmployees();
        await this.search();
    }
    public initializeBarChartHeight() {
        const barDiv = document.getElementById('bar_chart-div') as HTMLElement;
        if (barDiv) {
            barDiv.style.height = `3000px`;
        }
        const barChart = document.getElementById('bar_charts') as HTMLElement;
        if (barChart) {
            barChart.style.height = `3000px`;
        }
    }
    public createPiechart() {
        this.pieChartData = {
            type: "pie",
            data: {
                labels: this.employeeNameList,               
                datasets: [
                    {
                        data: this.requestCountList,
                        borderColor: '#000000',
                        backgroundColor: this.isEmptyPieChart ? '#bdc3c7' : this.getPieChartColors(this.requestCountList.length),
                        tension: 0,
                        borderWidth: 1,
                        fontColor: 'red',
                        fontStyle: 'bolder',
                        fontWeight: 'bold'
                    }],
            },
            options: {
                responsive: true, // Ensures it resizes with the container
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 50, // Adds space above the chart
                        bottom: 0, // Adds space below the chart
                    }, // Adds space around the chart inside the canvas
                },
                tooltips: {
                    enabled: true, // Enable tooltips on hover
                    bodyFontFamily: 'DIN Next LT Arabic',
                },
                plugins: {
                    datalabels: {
                        align: "end", // Moves text outside the pie chart
                        offset: 88, // Pushes labels outw
                        //anchor: "end", // Position outside the pie chart                   
                        clip: false, // Ensure text is not clipped
                        color: 'black',
                        font: {
                            size: 10,
                            family: 'DIN Next LT Arabic',  // Change font family
                        },
                        formatter: (value: number, context: any) => {
                            const total = context.dataset.data.reduce(
                                (sum: number, current: number) => sum + current, 0
                            );
                            const percentage = ((value / total) * 100).toFixed(1);
                            return ` ${percentage}%`;
                        },
                    },
                },
                legend: {
                    display: true, // Show the legend
                    offset: 20,
                    position: "bottom",
                    font: {
                        size: 200,// Set font size for legend labels
                        family: 'DIN Next LT Arabic',  // Change font family
                    },
                    labels: {
                        padding: 20,
                        anchor: "end", // Position the label outside the chart
                        align: "end", // Align the labels to the edge
                        offset: 20, //
                        fontColor: 'black',
                        fontFamily: 'DIN Next LT Arabic',                       
                    },
                },
            },
            plugins: [ChartDataLabels],
        };
        this.myPieChart = new Chart(document.getElementById('pie_charts'), this.pieChartData);
        if (process.env.VUE_APP_TITLE !== undefined && process.env.VUE_APP_LogoLayoutSrc !== undefined) {
            this.themeCompany = process.env.VUE_APP_TITLE.toString();
        }
    }

    public async exportToExcel() {
        var model = {
            requestId: this.filterModel.requestId,
            senderName: this.filterModel.senderName,
            processingById: this.filterModel.processingById,
            dateFrom: this.filterModel.dateFrom,
            dateTo: this.filterModel.dateTo,
            requestType: this.filterModel.requestType,
            requestStatus: this.filterModel.requestStatus,
        };
        const response = await this.employeeStatisticsService.ExportEmployeeStatistics
            (model);
    }
    public createBarChart() {
        var barChartElement = document.getElementById('bar_charts') as HTMLCanvasElement;
        if (barChartElement != null)
            this.ctx = barChartElement.getContext('2d');
        this.myBarChart = new Chart(this.ctx, {
            type: 'horizontalBar',
            data: {
                labels: this.employeeNameBarList,
                datasets: [{
                    label: 'Rejected Requests',
                    data: this.rejectedRequestCountBarList,
                    backgroundColor: this.rejectedColor,
                    borderColor: this.rejectedColor,
                    borderWidth: 1,
                    barThickness: 15,
                    barPercentage: 0.6, // Adjust the width of the bars
                    categoryPercentage: 0.8,
                  

                }, {
                    label: 'Approval Requests',
                    data: this.approvedRequestCountBarList,
                    backgroundColor: this.approvedColor,
                    borderColor: this.approvedColor,
                    borderWidth: 1,
                    barThickness: 15,
                    barPercentage: 0.6, // Adjust the width of the bars
                    categoryPercentage: 0.8
                }, {
                    label: 'Final Approval Request',
                    data: this.finalApprovesRequestCountBarList,
                    backgroundColor: this.finalApprovedColor,
                    borderColor: this.finalApprovedColor,
                    borderWidth: 1,
                    barThickness: 15,
                    barPercentage: 0.6, // Adjust the width of the bars
                    categoryPercentage: 0.8
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        ticks: {
                            display: false,
                            beginAtZero: true,
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            fontColor: 'black', // Set font color to black
                            fontSize: 14,
                            padding: 60,
                            fontFamily: 'DIN Next LT Arabic',
                            display: true, // Ensure the axis is displayed
                        },
                    }],
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top',
                            labels: {
                                fontColor: 'red', // Set font color to black for the legend
                                fontStyle: 'bold',  // Make font bold for the legend
                                fontSize: 14,       // Optional: Set font size for the legend
                                fontFamily: 'DIN Next LT Arabic', // 
                                font: {
                                    size: 100,           // Font size inside bars
                                    weight: 'bold',
                                    family: 'DIN Next LT Arabic',  // Change font family
                                },
                            },
                     
                        },
                    },
                },
                legend: {
                    font: {
                        size: 12,           // Font size inside bars
                        weight: 'bold',   
                        family: 'DIN Next LT Arabic',  // Change font family
                    },
                    position: "top",
                    labels: {
                        fontStyle: 'bold',  // Make font bold for the legend
                        fontSize: 14,
                        fontFamily: 'DIN Next LT Arabic',
                    },
                },
                plugins: {
                    legend: {
                        display: true,
                        labels: {                     
                            font: {
                                weight: 'bold', 
                                family: 'DIN Next LT Arabic',  // Change font family
                            },
                        }                      
                    },
                    datalabels: {
                        color: 'black', 
                        font: {
                            weight: 'bold', 
                            size: 50,// Set font size for legend labels
                            family: 'DIN Next LT Arabic',  // Change font family
                        },
                        display: false, // Hide data labels on the bars by default
                    },
                    tooltip: {
                        enabled: true, // Enable tooltips on hover
                        bodyFontFamily: 'DIN Next LT Arabic',
                    },
                },
                tooltips: {                    
                    titleFontFamily: 'DIN Next LT Arabic', // Tooltip title font family                
                }
            },
            plugins: [ChartDataLabels],
        });
        const elementdiv = document.getElementById('bar_chart-div') as HTMLElement;
        if (elementdiv) {
            elementdiv.style.height = `${60 * this.employeeNameBarList.length}px`;
        }
        const element = document.getElementById('bar_charts') as HTMLElement;
        if (element) {
            element.style.height = `${60 * this.employeeNameBarList.length}px`;
        }
    }
    public async getColors() {
        if (process.env.VUE_APP_TITLE !== undefined &&
            process.env.VUE_APP_LogoLayoutSrc !== undefined) {
            this.themeCompany = process.env.VUE_APP_TITLE.toString();
        }
        if (this.themeCompany == 'Mobily') {
            this.rejectedColor = '#6ce5e8';
            this.approvedColor = '#41b8d5';
            this.finalApprovedColor = '#0d8ea5';
            this.pieChartColors.push('#38b6ff');
            this.pieChartColors.push('#0097b2');
            this.pieChartColors.push('#31356e');
            this.pieChartColors.push('#6ce5e8');
            this.pieChartColors.push('#41b8d5');
            this.pieChartColors.push('#2f5f98');
            this.pieChartColors.push('#2e9bab');
        }
        else if (this.themeCompany == 'Zain') {
            this.rejectedColor = '#6bbd45';
            this.approvedColor = '#009032';
            this.finalApprovedColor = '#00713f';
            this.pieChartColors.push('#a8de6a');
            this.pieChartColors.push('#80bb3b');
            this.pieChartColors.push('#6cbd45');
            this.pieChartColors.push('#41ab49');
            this.pieChartColors.push('#268e26');
            this.pieChartColors.push('#2d8842');
            this.pieChartColors.push('#256f3b');
            this.pieChartColors.push('#1e5332');
        }
        else {
            this.rejectedColor = '#db67e3';
            this.approvedColor = '#a51aac';
            this.finalApprovedColor = '#711297';
            this.pieChartColors.push('#ecb1fd');
            this.pieChartColors.push('#cb6ce6');
            this.pieChartColors.push('#b944cf');
            this.pieChartColors.push('#9627af');
            this.pieChartColors.push('#7300a8');
            this.pieChartColors.push('#671a99');
            this.pieChartColors.push('#671a99');
        }
    }

    public async reset() {
        this.filterModel.requestId = '';
        this.filterModel.senderName = '';
        this.filterModel.processingById = '';
        this.filterModel.dateFrom = '';
        this.filterModel.dateTo = '';
        this.filterModel.requestType = 0;
        this.filterModel.requestStatus = 0;
        this.search();
    }

    public async search() {
        let model;
        model = {
            requestId: this.filterModel.requestId,
            senderName: this.filterModel.senderName,
            processingById: this.filterModel.processingById,
            dateFrom: this.filterModel.dateFrom,
            dateTo: this.filterModel.dateTo,
            requestType: this.filterModel.requestType,
            requestStatus: this.filterModel.requestStatus,
            pageIndex: '0',
            pagesize: '10',
        };
        const response = await this.employeeStatisticsService.Get(model);
        if (response !== false) {
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            }
        }
        this.senderRequestHistoryModel = response.result;
        this.sendersCount = response.totalCount;
    }

    public getPieChartColors = (count: number): string[] => {
        const list = this.pieChartColors;
        return list.length <= count
            ? Array.from({ length: count }, (_, i) => list[i % list.length])
            : list.slice(0, count);
    };

    public async updatePaginate(val: any) {
        const model = {
            requestId: this.filterModel.requestId,
            senderName: this.filterModel.senderName,
            processingById: this.filterModel.processingById,
            dateFrom: this.filterModel.dateFrom,
            dateTo: this.filterModel.dateTo,
            requestType: this.filterModel.requestType,
            requestStatus: this.filterModel.requestStatus,
            pageIndex: (val.page - 1).toString(),
            pagesize: val.rowsPerPage,
        };
        const response = await this.employeeStatisticsService.Get(model);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senderRequestHistoryModel = response.result;
        this.sendersCount = response.totalCount;
    }

    public async GetBoxes() {
        const response = await this.employeeStatisticsService.GetBoxes();
        if (response.isSuccess) {
            this.employeeStatisticsBoxModel = response.result;
        }
        else {
            Toaster.error(response.errorMessage);
        }
    }
    public async filter(requestStatus: number) {
        if (this.filterModel.requestStatus == requestStatus) {
            this.filterModel.requestStatus = 0;
        } else {
            this.filterModel.requestStatus = requestStatus;
        }
        await this.search();
        await this.GetPieChart();
        await this.UpdatePieChart();
        await this.GetBarChart();
        await this.UpdateBarChart();
        await this.UpdatePieChart();
    }
    public async apply() {
        await this.GetPieChart();
        await this.GetBarChart();
        await this.UpdatePieChart();
        await this.UpdateBarChart();
        await this.UpdatePieChart();
    }

    public async GetPieChart() {
        const response = await this.employeeStatisticsService.GetPieChart(this.viewBy, this.requestType, this.filterModel.requestStatus);
        if (response.isSuccess) {
            this.employeeStatisticsChartModelList = response.result;
            this.requestCountList = this.employeeStatisticsChartModelList.requestCount;
            this.employeeNameList = this.employeeStatisticsChartModelList.employeeName;
            if (this.employeeStatisticsChartModelList.employeeName.length == 0) {
                this.isEmptyPieChart = true;
                this.employeeNameList.push('N/A');
                this.requestCountList.push(1);
            }
            else {
                this.isEmptyPieChart = false;
            }
        }
        else {
            Toaster.error(response.errorMessage);
        }
    }

    public async GetAllEmployees() {
        const response = await this.employeeStatisticsService.getAllEmployees();
        if (response.isSuccess) {
            this.processingBy = response.result;
        }
        else {
            Toaster.error(response.errorMessage);
        }
    }
    public async GetBarChart() {
        const response = await this.employeeStatisticsService.GetBarChart(this.viewBy, this.requestType, this.filterModel.requestStatus);
        if (response.isSuccess) {
            this.employeeStatisticsBarChartModel = response.result;
            this.employeeNameBarList = this.employeeStatisticsBarChartModel.employeeNameList;
            this.rejectedRequestCountBarList = this.employeeStatisticsBarChartModel.rejectedRequestCountList;
            this.approvedRequestCountBarList = this.employeeStatisticsBarChartModel.approvalRequestCountList;
            this.finalApprovesRequestCountBarList = this.employeeStatisticsBarChartModel.finalApprovalRequestCountList;
        }
        else {
            Toaster.error(response.errorMessage);
        }
    }
    public async UpdatePieChart() {
        this.myBarChart.update();
        this.myPieChart.data.datasets[0].data = this.requestCountList;
        this.myPieChart.data.labels = this.employeeNameList;
        this.myPieChart.data.datasets[0].backgroundColor = this.isEmptyPieChart ? '#e5e8e8' : this.getPieChartColors(this.requestCountList.length);
        this.myPieChart.update();
    }
    public async UpdateBarChart() {
        this.myBarChart.data.datasets[0].data = this.rejectedRequestCountBarList;
        this.myBarChart.data.datasets[1].data = this.approvedRequestCountBarList;
        this.myBarChart.data.datasets[2].data = this.finalApprovesRequestCountBarList;
        this.myBarChart.data.labels = this.employeeNameBarList;
        this.myBarChart.update();
    }
}